import { mapDTO } from '@twistezo/ts-dto-mapper'

import { alertsFromDTO } from 'features/alerts/api/mappers/alertFromDTO'
import { DomainDTO } from '../api/types/domainDTO'
import { domainPrebidStackFromDTO } from '../domain/api/mappers/domainPrebidStack'
import { domainPriceGeniusFromDTO } from '../domain/api/mappers/domainPriceGenius'
import { domainRefresherFromDTO } from '../domain/api/mappers/domainRefresher'
import { domainRichPlacementInterstitialFromDTO } from '../domain/api/mappers/domainRichPlacementInterstitial'
import { domainRichPlacementKWordsFromDTO } from '../domain/api/mappers/domainRichPlacementKWords'
import { domainRichPlacementMultiAnchorFromDTO } from '../domain/api/mappers/domainRichPlacementMultiAnchor'
import { domainUnfilledRecoveryFromDTO } from '../domain/api/mappers/domainUnfilledRecovery'
import { domainViewabilityToolsFromDTO } from '../domain/api/mappers/domainViewabilityTools'
import { DomainAlert } from '../domain/types/DomainAlert'
import { Domain } from '../types/domain'
import { customCodeFromDTO } from './customCode'

export const domainFromDTO = (from: DomainDTO) =>
  mapDTO<DomainDTO, Domain>({ from }).transform(domainDTO => ({
    ...domainDTO,
    activeAbTest: domainDTO.activeAbTest ?? undefined,
    alerts: alertsFromDTO<DomainAlert>(domainDTO.alerts),
    createdAt: new Date(domainDTO.createdAt),
    customCode: customCodeFromDTO(domainDTO.customCode),
    domainPrebidStack: domainPrebidStackFromDTO(domainDTO.domainPrebidStack),
    domainPriceGenius: domainPriceGeniusFromDTO(domainDTO.domainPriceGenius),
    domainRefresher: domainRefresherFromDTO(domainDTO.domainRefresher),
    domainRichPlacementInterstitial: domainRichPlacementInterstitialFromDTO(
      domainDTO.domainRichPlacementInterstitialConfiguration,
    ),
    domainRichPlacementKWords: domainRichPlacementKWordsFromDTO(
      domainDTO.domainRichPlacementKwordsConfiguration,
    ),
    domainRichPlacementMultiAnchor: domainRichPlacementMultiAnchorFromDTO(
      domainDTO.domainRichPlacementMultianchorConfiguration,
    ),
    domainUnfilledRecovery: domainUnfilledRecoveryFromDTO(domainDTO.domainUnfilledRecovery),
    domainViewabilityTools: domainViewabilityToolsFromDTO(domainDTO.domainViewabilityTools),
    updatedAt: new Date(domainDTO.updatedAt),
  }))
